import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { useTheme } from '@mui/system';
import config from '@configFile';
import { DealPostType } from '@types';
import DiscountReceipt from '@components/DealSummary/components/DiscountReceipt';
import { getProductLink, parseTitle } from '@utils/index';
import { useGetDealSummary } from '@hooks/useGetDealSummary';
import RedeemStepsList from '@components/RedeemStepsList';
import DealEditorsNotes from '@components/DealEditorsNotes';
// import SubscribeSaveTip from '@components/SubscribeSaveTip';
import RelatedLists from '@pages/Blog/components/RelatedLists';
import RelatedDeals from '@pages/Blog/components/RelatedDeals';
import FeedLink from '@pages/Blog/components/FeedLink';
import CouponDeals from '@components/DealSummary/components/CouponDeals';
import AuthorBio from '@pages/Blog/components/AuthorBio';
import TopDealsCard from '@components/TopDealsCard';
import DealPostSummary from './DealPostSummary';

interface DealPostFeedCardProps {
  deal: DealPostType;
  relatedDeals?: DealPostType[];
  tag: string;
  showAdditionalInfo?: boolean;
  isMainContent?: boolean;
}

const DealPostFeedCardTabs = ({
  deal,
  relatedDeals = [],
  tag,
  showAdditionalInfo,
  isMainContent = false
}: DealPostFeedCardProps) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const { data: dealSummary } = useGetDealSummary(deal.ASIN);
  const filteredRelatedDeals = relatedDeals.filter((d) => d.ASIN !== deal.ASIN);
  return (
    <>
      <Box
        sx={{
          '@media (max-width: 540px)': {}
        }}
      >
        <DealPostSummary
          deal={deal}
          isExpired={!!dealSummary?.isExpired}
          tag={tag}
        />
        {/* {deal.ss ? <SubscribeSaveTip /> : null} */}
        <RedeemStepsList deal={dealSummary} />
        <DiscountReceipt receiptDeal={deal} tag={tag} />
        {dealSummary?.promoCode && dealSummary?.ASIN && (
          <>
            <CouponDeals
              promoCode={dealSummary?.promoCode}
              currentASIN={dealSummary?.ASIN}
              defaultExpanded={false}
              titleComponent={isMainContent ? 'h2' : 'h3'}
            />
          </>
        )}
        {dealSummary ? (
          <DealEditorsNotes deal={dealSummary} tag={tag} />
        ) : (
          <Box
            sx={{
              marginTop: '12px'
            }}
          >
            <Skeleton variant="rectangular" height={100} />
          </Box>
        )}
      </Box>
      <FeedLink
        backgroundColor="transparent"
        color={isDarkMode ? theme.palette.primary.text : '#424242'}
        target="_blank"
        rel="nofollow"
        href={getProductLink(deal.ASIN, tag, deal?.sLink || '')}
        text={
          <>
            See it at Amazon: <strong>{parseTitle(deal.title)}</strong>
          </>
        }
      />
      {showAdditionalInfo ? <AuthorBio /> : null}
      {filteredRelatedDeals.length > 0 ? (
        <>
          <RelatedDeals
            relatedDeals={filteredRelatedDeals}
            tag={config.AFFILIATE_TAGS.FEED_ADDITIONAL}
            ASIN={deal.ASIN}
          />
        </>
      ) : (
        <RelatedLists ASIN={deal.ASIN} />
      )}
      {showAdditionalInfo ? (
        <TopDealsCard
          tag={config.AFFILIATE_TAGS.JD_TOP_DEALS_DAY}
          renderInFeed
        />
      ) : null}
    </>
  );
};

export default DealPostFeedCardTabs;
